import * as Yup from "yup"

export const login_schema = Yup.object({
  username: Yup.string().required("this field is required"),
  password: Yup.string().required("this field is required"),
})

export const create_user_schema = Yup.object({
  user: Yup.object().shape({
    fullname: Yup.string().required("this field is required"),
    password: Yup.string().required("this field is required"),
    username: Yup.string().required("this field is required"),
    email: Yup.string()
      .email("please enter valid email")
      .required("this field is required"),
    phone: Yup.string().required("this field is required"),
  }),
})

export const edit_user_schema = Yup.object({
  user: Yup.object().shape({
    fullname: Yup.string().required("this field is required"),
    email: Yup.string()
      .email("please enter valid email")
      .required("this field is required"),
    phone: Yup.string().required("this field is required"),
  }),
})

export const change_password_schema = Yup.object({
  new_password1: Yup.string().required("this field is required").min(6),
  new_password2: Yup.string().required("this field is required").min(6),
})

export const update_profile_schema = Yup.object({
  fullname: Yup.string().required("this field is required"),
  email: Yup.string()
    .email("please enter valid email")
    .required("this field is required"),
})

export const create_client_schema = Yup.object({
  user: Yup.object().shape({
    fullname: Yup.string().required("this field is required"),
    email: Yup.string()
      .email("please enter valid email")
      .required("this field is required"),
    phone: Yup.string().required("this field is required"),
    username: Yup.string().required("this field is required"),
    password: Yup.string().required("this field is required"),
  }),
  address: Yup.string().required("this field is required"),
  company: Yup.string().required("this field is required"),
  package: Yup.string().required("this field is required"),
})

export const edit_client_schema = Yup.object({
  user: Yup.object().shape({
    fullname: Yup.string().required("this field is required"),
    email: Yup.string()
      .email("please enter valid email")
      .required("this field is required"),
    phone: Yup.string().required("this field is required"),
  }),
  address: Yup.string().required("this field is required"),
  company: Yup.string().required("this field is required"),
  package: Yup.string().required("this field is required"),
})

export const folder_schema = Yup.object({
  name: Yup.string().required("this field is required"),
  group: Yup.object().shape({
    conditions: Yup.array().of(
      Yup.object().shape({
        type: Yup.string().required("this field is required"),
        value: Yup.string().required("this field is required"),
        expression: Yup.string().required("this field is required"),
      })
    ),
  }),
})
